import {
    QuoteStatus,
    QuoteType,
    type FixedPriceQuoteResource,
    type TimeAndMaterialsQuoteResource,
    type QuoteResource,
    QuoteAcceptanceBlockingReason,
} from '@api';

export function isQuoteFixedPrice(quote?: QuoteResource | null): quote is FixedPriceQuoteResource {
    return quote?.type === QuoteType.FixedPrice;
}

export function isQuoteTimeAndMaterials(quote?: QuoteResource | null): quote is TimeAndMaterialsQuoteResource {
    return quote?.type === QuoteType.TimeAndMaterials;
}

const ACTIONABLE_QUOTE_STATUSES: QuoteStatus[] = [QuoteStatus.Submitted, QuoteStatus.AcceptanceBlocked];

export function isQuoteActionable(quote?: Pick<QuoteResource, 'status'> | null): boolean {
    return !!quote && ACTIONABLE_QUOTE_STATUSES.includes(quote.status);
}

export function isQuoteAcceptanceBlockedFor(quote: Pick<QuoteResource, 'options'>, reason: QuoteAcceptanceBlockingReason) {
    return quote?.options.acceptanceBlockingReason === reason;
}

export function isQuotePrepayment(quote?: QuoteResource | null): boolean {
    return quote?.options.isPrepayment === true;
}

export function isQuoteTimeAndMaterialsWithAtLeastNLots(minNumberOfLots: number, quote?: TimeAndMaterialsQuoteResource | null) {
    return (quote?.details?.estimatedTotalLots ?? 0) >= minNumberOfLots;
}
